import { render, staticRenderFns } from "./agGrid.vue?vue&type=template&id=2db161ec"
import script from "./agGrid.vue?vue&type=script&lang=js"
export * from "./agGrid.vue?vue&type=script&lang=js"
import style0 from "./agGrid.vue?vue&type=style&index=0&id=2db161ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports